const popupRules = [
  {
    featureName: 'NetworkTokenization',
    requiredParams: ['TokenizationByCardSchemeBaseUrl'],
    excludedDetailCodes: ['MP10001']
  }
]

export const findPopupData = (subscriptions = [], rules = popupRules) => {
  for (const rule of rules) {
    const vas = subscriptions.find((subscription) => subscription?.feature?.name === rule?.featureName)
    if (!vas) continue

    const isExcluded = (rule?.excludedDetailCodes || []).includes(vas?.detail?.code)
    if (isExcluded) continue

    const params = vas?.params || []
    const missingRequired = (rule?.requiredParams || []).some((paramName) => {
      const match = params.find((subscriptionParam) => subscriptionParam?.featureParam?.name === paramName)
      return match && !match?.value
    })

    if (params.length === 0 || missingRequired) return { vas, rule }
  }

  return null
}

export const getFeatureParamsValue = (featureObj, featureName, featureParamName) => {
  const feature = Array.isArray(featureObj)
    ? featureObj.find((item) => item?.feature?.name === featureName)
    : featureObj

  if (!feature || feature?.feature?.name !== featureName || !featureParamName) {
    return null
  }

  const param = (feature?.params || []).find(
    (item) =>
      (item?.featureParam?.name || '').toUpperCase() ===
      String(featureParamName).toUpperCase()
  )

  return param?.value ?? null
}